var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mf-tabs-button',{staticClass:"ml-2",attrs:{"size":"sm","buttons":_vm.buttons},model:{value:(_vm.chartType),callback:function ($$v) {_vm.chartType=$$v},expression:"chartType"}})}
var staticRenderFns = []

export { render, staticRenderFns }